// extracted by mini-css-extract-plugin
export default {"weights":"weights__duI_D","level":"level__IYdhB"};